export function isBoolean(value: unknown) {
  return typeof value === 'boolean';
}
